<div class="bottom-navigation-bar">
  <button #homeBtn mat-ripple routerLinkActive="active" routerLink="/" [routerLinkActiveOptions]="{ exact: true }">
    <mat-icon [fontSet]="homeBtn.classList.contains('active') ? 'mat-symbol-round-fill' : 'mat-symbol-round'">
      home
    </mat-icon>
    <span>خانه</span>
  </button>
  <button
    mat-ripple
    #searchBtn
    routerLinkActive="active"
    routerLink="/search"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <mat-icon [fontSet]="searchBtn.classList.contains('active') ? 'mat-symbol-round-fill' : 'mat-symbol-round'">
      search
    </mat-icon>
    <span>جستجو</span>
  </button>
  @if (userInfo()) {
    <div class="dashed-profile">
      @if (remainingDays() !== undefined && showRemainingTooltip()) {
        @if (remainingDays()! <= 7 && remainingDays()! > 0) {
          <div [class]="['remaining-tooltip', 'remaining-day__' + remainingDays()]">
            {{ remainingDays() }} روز تا پایان اشتراک
          </div>
        } @else {
          <div class="remaining-tooltip remaining-day__0">اشتراک ندارید</div>
        }
      }

      <button mat-ripple routerLinkActive="active" routerLink="/profile" [routerLinkActiveOptions]="{ exact: true }">
        @if (remainingDays() !== undefined) {
          @if (remainingDays()! > 7) {
            <div class="basic-ring"></div>
          } @else {
            <app-dashed-ring [colors]="handleDashedColor" [strokeWidth]="3" />
          }
        }
        <app-image-generator
          [sizes]="profileSizes"
          class="avatar-image"
          imageType="square"
          [src]="userInfo()?.activeProfile?.avatar!"
          [name]="userInfo()?.activeProfile?.name"
        />
        <span>پروفایل</span>
      </button>
    </div>
  } @else {
    <button
      mat-ripple
      #loginBtn
      routerLinkActive="active"
      routerLink="/auth"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <mat-icon [fontSet]="loginBtn.classList.contains('active') ? 'mat-symbol-round-fill' : 'mat-symbol-round'">
        person
      </mat-icon>
      <span>ورود</span>
    </button>
  }
</div>
